/**
 * CTA Component - WorkStream
 * Call to Action reutilizável
 */
import { ChevronRight } from 'lucide-react'

interface CTAProps {
  variant?: 'gradient' | 'dark' | 'light'
  title?: string
  description?: string
  primaryText?: string
  primaryHref?: string
  secondaryText?: string
  secondaryHref?: string
}

export default function CTA({
  variant = 'gradient',
  title = 'Pronto para transformar sua gestão?',
  description = 'Comece gratuitamente por 14 dias. Sem cartão de crédito.',
  primaryText = 'Começar Teste Grátis',
  primaryHref = 'https://app.workstream.com.br/auth/signup',
  secondaryText = 'Falar com Vendas',
  secondaryHref = '/#contact',
}: CTAProps) {
  const bgStyles = {
    gradient: 'bg-gradient-to-r from-cyan-500/10 via-blue-500/5 to-transparent',
    dark: 'bg-[#0F172A]',
    light: 'bg-slate-800/30',
  }

  return (
    <section className={`py-24 relative overflow-hidden ${bgStyles[variant]}`}>
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-30" style={{
        backgroundImage: 'linear-gradient(rgba(6, 182, 212, 0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(6, 182, 212, 0.03) 1px, transparent 1px)',
        backgroundSize: '40px 40px'
      }} />
      
      <div className="relative max-w-4xl mx-auto px-4 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
          {title}
        </h2>
        <p className="text-lg text-slate-400 mb-8 max-w-2xl mx-auto">
          {description}
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <a
            href={primaryHref}
            className="px-8 py-4 rounded-xl font-semibold text-white flex items-center gap-2 transition-all hover:-translate-y-1"
            style={{ 
              background: 'linear-gradient(135deg, #00C6FF 0%, #0072FF 100%)',
              boxShadow: '0 4px 14px 0 rgba(0, 198, 255, 0.39)'
            }}
          >
            {primaryText}
            <ChevronRight className="w-5 h-5" />
          </a>
          {secondaryText && (
            <a
              href={secondaryHref}
              className="px-8 py-4 rounded-xl font-semibold bg-slate-800 text-white border border-slate-700 hover:bg-slate-700 transition-all"
            >
              {secondaryText}
            </a>
          )}
        </div>
      </div>
    </section>
  )
}
